import { State } from './types';

const initialState: State = {
	translations: null
};

export default initialState;
